<template>
  <div style="height:100%">
    <SplitContainer2 style="height:100%" layout="horizontal" :split_setting="0.55">
      <template #table1>
        <TableMain name="myName" ref="GuestVendTable1" :fields="fields" :title="table_title.title1"
          :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_date_picker="true"
          :show_toolbar="false" :show_filter="true" :selectable="true" :table_height_adjust="-8"
          :hb_table_class="'hb_table_PurchaseOrder_class1'" :isBusy="isBusy_table1" @on_query="on_query"
          :check_state="true" @current_changed="query_delivery_plan">
          <template #query>
            {{ $t("common.purch_order_num") }}：<el-input clearable size="small" style="width: 150px"
              v-model="PurchId"></el-input>
          </template>
        </TableMain>
      </template>
      <template #table2>
        <TableMain ref="GuestVendTable3" :fields="delivery_plan_fileds" :isBusy="isBusy_table3"
          :show_query_container="false" :title="table_title.title3" :date_picker_label="date_picker_label"
          :table_height_adjust="8" :show_filter="false" :show_pagination="show_pagination" :pager_count="5"
          :loading_width="85" @state_change="table3_state_change" :show_toolbar_button="[0, 0, 0, 0, 1]"
          :hb_table_class="'hb_table_guest_sods_add_class3'">
          <template #toolbar="">
            <el-button type="info" plain style="width: 55px" class="ml-2" @click="AddDelivery"><i
                class="fa fa-plus"></i></el-button>
          </template>
          <template #operation>
            <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="saveDelivery"
              :label="$t('common.save')" class="ml-2">
            </QueryButton>
          </template>
        </TableMain>
      </template>
    </SplitContainer2>
  </div>

</template>

<script>
// import axios from "axios"
// -- import * as _ from "lodash-es"
import * as api from "@/shared/api"
import { Split } from "view-design"
import "view-design/dist/styles/iview.css"
import * as GuestController from "../../controllers/pages/GuestController"
import * as localStorageMgr from "../../shared/localStorageMgr"
import EntityEditor from "../components/base/EntityEditor"
import QueryButton from "../components/base/QueryButton"
import TestQueryPanel from "../components/base/TestQueryPanel"
import BaseContainer from "../components/BaseContainer"
import SplitContainer2 from "../components/container/SplitContainer2"
import TableDetail from "../components/table/TableDetail"
import TableMain from "../components/table/TableMain"

export default {
  name: "GuestVend",
  components: {
    QueryButton,
    TableDetail,
    TableMain,
    TestQueryPanel,
    BaseContainer,
    EntityEditor,
    Split,
    SplitContainer2,
  },
  data() {
    return {
      guest_info: null,
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_purch_order",
        title2: "table_purch_order_detail",
        title3: "交货计划列表",
      },
      fields: GuestController.fields.default,
      itemfields: GuestController.fields.item_fields,
      delivery_plan_fileds: GuestController.fields.delivery_plan_fileds,
      isBusy_table1: false,
      isBusy_table2: false,
      isBusy_table3: false,
      show_pagination: false,
      PurchId: "",
    }
  },
  created() {
    this.guest_info = JSON.parse(this.ls.get(localStorageMgr.data.guest_info))
  },
  methods: {
    ///查询
    async on_query(set_data, date_range) {
      this.isBusy_table1 = true
      set_data([])
      let _fromDate = "",
        _toDate = ""
      let _params = {
        pub_token: this.ls.get("pub_guest_token"),
        PurchId: this.PurchId,
      }
      if (!_.isNull(date_range) && this.PurchId == "") {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        _params["fromDate"] = _fromDate
        _params["toDate"] = _toDate
      }
      let _result = await api.query_async({
        url: api.pub_url("get", this.guest_info.idx, "pub_get_vend_purchase_order"),
        parameters: _params,
        method: "get",
      })


      if (
        _result &&
        _result[0] &&
        _result[0].result &&
        _result[0].result.data &&
        _result[0].result.data.Result &&
        _result[0].result.data.Result[0]
      ) {
        set_data(_result[0].result.data.Result[0])
      }

      this.isBusy_table1 = false
    },
    async current_changed(old, current) {
      if (_.isNull(current)) {
        this.$refs.GuestVendTable1.SetData([])
        return
      }
      this.isBusy_table2 = true

      let _result = await api.query_async({
        url: api.pub_url("get", this.guest_info.idx, "pub_get_vend_purchase_order_line"),
        parameters: {
          pub_token: this.ls.get("pub_guest_token"),
          PurchaseOrderId: current.id,
        },
        method: "get",
      })


      if (
        _result &&
        _result[0] &&
        _result[0].result &&
        _result[0].result.data &&
        _result[0].result.data.Result &&
        _result[0].result.data.Result[0]
      ) {
        this.$refs.GuestVendTable1.SetData(
          _.orderBy(_result[0].result.data.Result[0], ["LineNumber"], ["asc"])
        )
      }

      this.isBusy_table2 = false
    },
    async query_delivery_plan(old, current) {
      if (_.isNull(current)) {
        this.$refs.GuestVendTable3.SetData([])
        return
      }
      this.isBusy_table3 = true

      let _result = await api.query_async({
        url: api.pub_url("get", this.guest_info.idx, "pub_get_vend_purchase_order_delivery"),
        parameters: {
          pub_token: this.ls.get("pub_guest_token"),
          PurchId: current.PurchId,
          LineNumber: current.LineNumber,
        },
        method: "get",
      })


      if (
        _result &&
        _result[0] &&
        _result[0].result &&
        _result[0].result.data &&
        _result[0].result.data.Result &&
        _result[0].result.data.Result[0]
      ) {
        this.$refs.GuestVendTable3.SetData(
          _.orderBy(_result[0].result.data.Result[0], ["LineNumber"], ["asc"])
        )
      }

      this.isBusy_table3 = false
    },

    ///===保存及相关操作
    AddDelivery() {
      let _this = this
      let _append_items = []
      let _purch_line = this.$refs.GuestVendTable1.GetCurrentItem()
      if (_.isNull(_purch_line) || !_purch_line) {
        this.msgToasts("请选择采购订单明细！", "info")
        return
      }

      let _m = _.cloneDeep(GuestController.dataForm)
      _m.id = ""
      _m.PurchId = _purch_line.PurchId //采购单号
      _m.LineNumber = _purch_line.LineNumber //行号
      _m.OrderAccount = _purch_line.OrderAccount
      _m.PurchQty = _purch_line.PurchQty //采购单数量
      _m.DeliveryQty = 0 //计划数量
      _m.DeliveryDate = _this.$date.format(new Date(), "yyyy-MM-dd")
      _m.Remark = ""

      _append_items.push(_m)

      if (this.$refs.GuestVendTable3.my_data.length > 0) {
        this.$refs.GuestVendTable3.AppendItems(_append_items)
      } else {
        this.$refs.GuestVendTable3.SetData(_append_items)
      }
      if (
        this.$refs.GuestVendTable3.my_data &&
        this.$refs.GuestVendTable3.my_data.length > 50
      ) {
        this.show_pagination = true
      }
    },
    //状态改变
    table3_state_change(data, cb) {
      let _this = this
      if (data.state === "deleted") {
        this.msgModal(this.$t("notify.is_deleted")).then(async (v) => {
          if (v) {
            let query_settings = []
            let _del_list = data.selected_items
            if (_del_list && _del_list.length > 0) {
              _.each(_del_list, (t) => {
                let _m = new FormData()
                _m.append("id", t.id)
                query_settings.push({
                  url: api.pub_url("save", this.guest_info.idx, "pub_delete_vend_purchase_order_delivery"),
                  parameters: _m,
                  method: "post",
                })
              })
              let _result = await api.query_all_async(query_settings)
              if (_result && _result.length > 0) {
                this.$refs.GuestVendTable3.RemoveItems(data.selected_items)
                this.msgToasts(this.$t("notify.action_successfully"), "success")
                cb(true)
              } else {
                this.msgToasts(this.$t("notify.action_unsuccessfully"), "info")
                cb(false)
              }
            }
          }
        })
      }
    },
    //保存交货计划
    async saveDelivery(cb) {
      let _this = this
      if (this.$refs.GuestVendTable3.my_data.length == 0) {
        cb(true)
        return
      }
      //数据检测
      let _is_check_ok = this.validData(this.$refs.GuestVendTable3.my_data)
      if (!_is_check_ok) {
        cb(true)
        return
      }
      //新增or修改
      let query_settings = []
      let data = _.cloneDeep(this.$refs.GuestVendTable3.my_data)
      _.each(data, (t) => {
        if (_.isInteger(t.id)) {
          let _m = new FormData()
          _m.append("id", t.id)
          _m.append("DeliveryQty", t.DeliveryQty)
          _m.append(
            "DeliveryDate",
            this.formatDate(t.DeliveryDate)
          )
          _m.append("Remark", t.Remark)
          query_settings.push({
            url: api.pub_url("save", this.guest_info.idx, "pub_update_vend_purchase_order_delivery"),
            parameters: _m,
            method: "post",
          })
        } else {
          let _m = new FormData()
          _m.append("PurchId", t.PurchId)
          _m.append("LineNumber", t.LineNumber)
          _m.append("OrderAccount", t.OrderAccount)
          _m.append("PurchQty", t.PurchQty)
          _m.append("DeliveryQty", t.DeliveryQty)
          _m.append("DeliveryDate", this.formatDate(t.DeliveryDate))
          _m.append("Remark", t.Remark)
          query_settings.push({
            url: api.pub_url("save", this.guest_info.idx, "pub_insert_vend_purchase_order_delivery"),
            parameters: _m,
            method: "post",
          })
        }
      })
      let _result = await api.query_all_async(query_settings)

      if (_result && _result.length > 0) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        let _line_m = this.$refs.GuestVendTable1.GetCurrentItem()
        this.query_delivery_plan(null, _line_m)
        cb(true)
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "info")
        cb(false)
      }
    },
    //数据检测
    validData(data) {

      ///检查是否重复交货日期
      let _is_qty_ok = true
      _.each(data, (t) => {
        t.DeliveryDate = this.$date.format(new Date(this.formatDate(t.DeliveryDate)), "yyyy-MM-dd")
        if (t.DeliveryQty == "" || _.isNull(t.DeliveryQty) || parseFloat(t.DeliveryQty) == 0) {
          _is_qty_ok = false
        }
      })
      if (!_is_qty_ok) {
        this.msgToasts(this.$t("notify.not_pcs"), "info")
        return _is_qty_ok
      }
      let _cd = _.groupBy(data, "DeliveryDate")
      let _is_repeat = false
      for (var i in _cd) {
        if (_cd[i].length > 1) {
          _is_repeat = true
          break
        }
      }
      if (_is_repeat) {
        this.msgToasts(this.$t("notify.delivery_date_exist"), "info")
        return !_is_repeat
      }
      //按单号拆分
      let _line_m = this.$refs.GuestVendTable1.GetCurrentItem()
      let _msg = ""
      let sum = _.sumBy(data, "DeliveryQty")
      if (sum > _line_m.PurchQty) {
        _msg = "计划交货数量不能超过采购订单数量！"
      }
      // else {
      //   if (_line_m && !_.isNull(_line_m.DeliveryDate)) {
      //     _.each(data, (t) => {
      //       if (
      //         new Date(t.DeliveryDate).getTime() >
      //         new Date(_line_m.DeliveryDate).getTime()
      //       ) {
      //         _msg = "计划日期不能超过交期！";
      //       }
      //     });
      //   }
      // }

      if (_msg != "") {
        this.msgToasts(_msg, "error")
        return false
      }
      return true
    },
  },
}
</script>
<style>
.hb_table_PurchaseOrder_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 130rem;
}

.hb_table_PurchaseOrder_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 100rem;
}

.hb_table_guest_sods_add_class3 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 50rem;
}

.hideId {
  display: none;
}
</style>

<style scoped>
.one_table>>>.hb_table_query_container_one_table {
  background-color: white;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_thead>.hb_thead_tr>.b-table-sticky-column.hb_thead_th_name {
  left: 21px;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_tbody>.hb_tbody_tr>.b-table-sticky-column.hb_tbody_td_name {
  left: 21px;
}
</style>
